export default {"src":"/_next/static/media/not_found_any_product.4c08f45c.svg","height":108,"width":188};